import { useState, useEffect } from "react";
import { Layout, theme, Button, message, Input } from "antd";
import { BranchesOutlined, PlusOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import TopBar from "../../components/TopBar";
import SideBar from "../../components/SideBar";
import { AddBranchModal } from "../../components/ModalForm";
import { BranchTable } from "../../components/Table";

import "../../styles/Agents.css";

const { Content } = Layout;
const { Search } = Input;

const BranchPage: React.FC = () => {
  const [branches, setBranches] = useState<any>([]);
  const [branch, setBranch] = useState<any>({});
  const [filtered, setFiltered] = useState<any>([]);
  const [show, setShow] = useState(false);
  const [update, setUpdate] = useState(false);
  const [isActive, setActive] = useState(true);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  setTimeout(() => {
    setActive(false);
  }, 1000);

  const showModal = () => {
    setShow(!show);
    setUpdate(false);
  };

  const showEditModal = (data: any) => {
    // const formData = {
    //   id: data.id,
    //   Name: data.Name,
    //   Surname: data.Surname,
    //   Cellphone: data.Cellphone,
    //   Email: data.Email,
    //   Group: data.Group.map((item: any) => ({
    //     value: item.id,
    //     label: item.GroupName,
    //   })),
    // };
    // setUser(formData);
    // setShow(!show);
    // setUpdate(true);
  };

  const handleAdd = async (data: any) => {
    // return await addBranchApi(data)
    //   .then((res) => {
    //     setBranches([...branches, res.data]);
    //     return res;
    //   })
    //   .catch((err) => {
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  const handleUpdate = async (id: string, data: any) => {
    // return await editBranchApi(id, data)
    //   .then((res) => {
    //     const uppdatedBranches = branches.map((user: any) => {
    //       if (id === user.id) {
    //         return { ...user, ...res.data };
    //       }
    //       return user;
    //     });
    //     setBranches(uppdatedBranches);
    //     return res;
    //   })
    //   .catch((err) => {
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  const handleDelete = (id: string) => {
    // removeBranchApi(id)
    //   .then((res) => {
    //     const deleted = res.data;
    //     setBranches(branches.filter((branch: any) => branch.id !== deleted.id));
    //     return res;
    //   })
    //   .catch((err) => {
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  const onSearch = (e: any) => {
    // const value = e.target.value;
    // if (value !== "") {
    //   const filteredData = branches.filter((row: any) => {
    //     return Object.values(row)
    //       .join(" ")
    //       .toLowerCase()
    //       .includes(value.toLowerCase());
    //   });
    //   setFiltered(filteredData);
    // }
  };

  useEffect(() => {
    // getBranchesApi()
    //   .then((res) => {
    //     setBranches(res.data);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }, []);

  return (
    <LoadingOverlay active={isActive} spinner>
      <Layout style={{ minHeight: "100vh" }}>
        <SideBar />
        <Layout className="site-layout">
          <TopBar />
          <Content>
            <div
              style={{
                padding: 24,
                minHeight: "100%",
                background: colorBgContainer,
              }}
            >
              <h2>
                <BranchesOutlined
                  style={{ paddingRight: "5px", color: "#f04f05" }}
                />
                Branches
              </h2>
              <div className="interactions">
                <Button onClick={showModal} size="large">
                  <PlusOutlined style={{ paddingRight: "5px" }} />
                  Add Branch
                </Button>

                <div>
                  <Search
                    placeholder="Search"
                    size="large"
                    onChange={(e) => onSearch(e)}
                    style={{ width: "100%", margin: "24px 0" }}
                  />
                </div>

                {/* Add Edit Modal */}

                <AddBranchModal
                  show={show}
                  showModal={showModal}
                  handleAdd={handleAdd}
                />
              </div>

              <BranchTable
                branches={branches}
                filtered={filtered}
                showEditModal={showEditModal}
                handleDelete={handleDelete}
              />
            </div>
          </Content>
        </Layout>
      </Layout>
    </LoadingOverlay>
  );
};

export default BranchPage;
